import styled from 'styled-components';

import Text from '@wecasa/web-ui/src/components/base-text/variants/text';
import TextButton from '@wecasa/web-ui/src/components/button/text-button';
import Skeleton from '@wecasa/web-ui/src/components/skeleton/skeleton';

import { calculationLineStyle } from '../../../../../common/common';

export const PriceLineWrapper = styled.div`
  ${calculationLineStyle}
  align-items: flex-start;
  column-gap: 20px;
`;

export const PriceLineLabel = styled.div`
  flex: 1;
  white-space: normal;
`;

type PriceLineProps = {
  text: string;
  price: string;
  isPriceStrikedOut?: boolean;
  isBold?: boolean;
  isLoading: boolean;
};

export const PriceLine = ({ text, price, isPriceStrikedOut = false, isBold = false, isLoading }: PriceLineProps) => {
  const TextLine = isBold ? Text.MDBold : Text;
  return (
    <PriceLineWrapper>
      <PriceLineLabel>
        <TextLine>{text}</TextLine>
      </PriceLineLabel>
      {isLoading ? <Skeleton linesWidth={['60px']} /> : <TextLine strikedOut={isPriceStrikedOut}>{price}</TextLine>}
    </PriceLineWrapper>
  );
};

type PriceLineTextButtonProps = {
  text: string;
  price: string;
  onPress: (val?: any) => void;
  isLoading: boolean;
};

export const PriceLineTextButton = ({ text, price, onPress, isLoading }: PriceLineTextButtonProps) => (
  <PriceLineWrapper>
    <TextButton onClick={onPress}>{text}</TextButton>
    {isLoading ? <Skeleton linesWidth={['60px']} /> : <Text>{`- ${price}`}</Text>}
  </PriceLineWrapper>
);
